import React, { Component } from "react";
// core components
import NavPills from "components/NavPills/NavPills.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import MUIDataTable from "mui-datatables";
import SearchIco from "@material-ui/icons/Search";
import Button from "components/CustomButtons/Button.jsx";
import PropTypes from "prop-types";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import GridList from "@material-ui/core/GridList";
import { fetchVesselPtmSourcerev } from "../../api/portal";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
  fetchPortAll,
  fetchShipSearch,
  fetchShipTracker,
  fetchShipLine
} from "../../api/portal";
import { pushLeftPanel } from "actions/dashboard";
import { pushPoiTarget } from "actions/portal";
import MenuItem from "@material-ui/core/MenuItem";
import _ from "lodash";
import { pushLoader } from "../../actions/main";
import ReactExport from "assets/libs/react-export-excel";
import moment from "moment";
import { withRouter } from "react-router-dom";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const fileName = `Vessel Position ${moment().format("LLL")}`;

const styles = theme => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2)
  }
});

class Vesselposition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      datatable: [],
      shiptracker: [],
      selectedCategory: 0,
      loader: null,
      sourceAis: "GPS"
    };
  }

  UNSAFE_componentWillMount() {
    this.props.pushLoader(true);
    this.setState({ loader: true });
    fetchVesselPtmSourcerev(this.state.sourceAis)
      .then(response => {
        //this.props.pushLoader(false);
        this.setState({ datatable: response.data.results });
        this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });
  }

  handlecatSource = e => {
    this.setState({ sourceAis: e.target.value });

    this.props.pushLoader(true);
    this.setState({ loader: true });
    fetchVesselPtmSourcerev(e.target.value)
      .then(response => {
        this.setState({ datatable: response.data.results });
        this.props.pushLoader(false);
        this.setState({ loader: false });
      })
      .catch(error => {
        console.log(error);
        // this.props.history.push("/pages/login#logout");
      });
  };

  renderShipTracker = e => {
    return <MenuItem value={e.shipid}> {e.name} </MenuItem>;
  };

  getNameshiptype = shiptype => {
    let shipTypeString;
    switch (shiptype) {
      case 1:
        shipTypeString = "Unspecified Ships";
        break;
      case 2:
        shipTypeString = "Fishing";
        break;
      case 3:
        shipTypeString = "Tugs & Special Craft";
        break;
      case 4:
        shipTypeString = "High Speed Craft";
        break;
      case 5:
        shipTypeString = "Pleasure Craft";
        break;
      case 6:
        shipTypeString = "Passenger Vessel";
        break;
      case 7:
        shipTypeString = "Cargo Vessel";
        break;
      case 8:
        shipTypeString = "Tanker";
        break;

      case 99:
        shipTypeString = "Pertamina";
        break;
      default:
        shipTypeString = "n/a";
        break;
    }

    return shipTypeString;
  };

  render() {
    const { classes } = this.props;
    const columns = [
      {
        name: "shipname",
        label: "Vessel Name",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "call_sign",
        label: "Call Sign",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "destination",
        label: "Destination",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "geofenceport_name",
        label: "Port Coverage",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "geofenceport_status",
        label: "Port Coverage Status",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "imo",
        label: "IMO",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "ownership_status",
        label: "Ownership",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "vessel_status",
        label: "Hire Status",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "proggramer",
        label: "Programmer",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "ipman_activity",
        label: "Activity",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "ipman_ata",
        label: "ATA",
        options: {
          filter: false,
          display: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            if (value) {
              return moment(value).format("DD-MM-YYYY HH:mm:ss");
            }
          }
        }
      },
      {
        name: "ipman_eta",
        label: "ETA",
        options: {
          filter: false,
          display: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            if (value) {
              return moment(value).format("DD-MM-YYYY HH:mm:ss");
            }
          }
        }
      },
      {
        name: "ipman_container",
        label: "Cargo",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "ipman_container_value",
        label: "Cargo Qty",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "ipman_plant",
        label: "Plant",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "status_name",
        label: "Status",
        options: {
          filter: false,
          display: true
        }
      },

      {
        name: "ship_id",
        label: "Ship Id",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "shiptype",
        label: "Ship Type",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "vessel_category",
        label: "Vessel Category",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "date_created",
        label: "Last Update",
        options: {
          filter: false,
          display: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            if (value) {
              return moment(value).format("DD-MM-YYYY HH:mm:ss");
            }
          }
        }
      },
      {
        name: "lat",
        label: "Latitude",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "lon",
        label: "Longitude",
        options: {
          filter: false,
          display: true
        }
      }
    ];

    const options = {
      filter: true,
      search: true,
      selectableRows: false,
      print: true,
      download: true,
      responsive: "scroll",
      viewColumns: true,
      onRowClick: e => {
        this.handleRowSelect(e);
      },
      textLabels: {
        body: {
          noMatch: this.state.loader
            ? "Searching..."
            : "Sorry, no matching records found"
        }
      }
    };

    return (
      <GridItem xs={12}>
        <div className={classes.content}>
          <GridItem xs={12}>
            <ExcelFile
              element={
                <Button
                  color="primary"
                  variant="contained"
                  disabled={this.state.loader}
                >
                  Download as .xslx
                </Button>
              }
              filename={`${fileName}`}
              fileExtension="xslx"
            >
              <ExcelSheet data={this.state.datatable} name="Sheet 1">
                <ExcelColumn label="Vessel Name" value="shipname" />
                <ExcelColumn label="Destination" value="destination" />
                <ExcelColumn label="Port Coverage" value="geofenceport_name" />
                <ExcelColumn label="IMO" value="imo" />
                <ExcelColumn
                  label="Ownership Status"
                  value="ownership_status"
                />
                <ExcelColumn label="Hire Status" value="vessel_status" />
                <ExcelColumn label="Programmer" value="proggramer" />
                <ExcelColumn label="Activity" value="ipman_activity" />
                <ExcelColumn label="Cargo" value="ipman_container" />
                <ExcelColumn label="Cargo QTY" value="ipman_container_value" />
                <ExcelColumn label="Plant" value="ipman_plant" />
                <ExcelColumn label="Status" value="status_name" />
                <ExcelColumn label="Shiptype" value="shiptype" />
                <ExcelColumn label="Vessel Category" value="vessel_category" />
                <ExcelColumn label="Last Update" value="date_created" />
                <ExcelColumn label="Latitude" value="lat" />
                <ExcelColumn label="Longitude" value="lon" />
              </ExcelSheet>
            </ExcelFile>
            <FormControl variant="outlined" style={{ paddingTop: "4px" }}>
              <Select
                value={this.state.sourceAis}
                onChange={this.handlecatSource}
                style={{ height: "43px" }}
              >
                <MenuItem value="AIS_MT"> AIS </MenuItem>
                <MenuItem value="GPS"> GPS </MenuItem>
              </Select>
            </FormControl>
          </GridItem>
          <GridItem xs={12}>
            <MUIDataTable
              data={this.state.datatable}
              columns={columns}
              options={options}
            />
          </GridItem>
        </div>
      </GridItem>
    );
  }
}

Vesselposition.propTypes = {
  pushLeftPanel: PropTypes.array
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    rightPanel: state.rightPanel,
    leftPanel: state.leftPanel
  };
}

export default withRouter(connect(
  mapStateToProps,
  { pushLeftPanel, pushPoiTarget, pushLoader }
)(withStyles(styles)(Vesselposition)));
